import React, { useState } from "react";
import { Button, message, Space, Input, Empty } from "antd";
//
//component
//redux
//selector
//actions
//function
//str

import { addSupporter } from "store/bailiff/dev/dev.action";
const DevScreen = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------

  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleGenerate = () => {
    addSupporter();
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN ----------------------------
  return (
    <div
      className="content-no-bg"
      style={{ width: "100%", padding: 20, minHeight: "100vh" }}
    >
      <Space>
        <Button onClick={handleGenerate}>Add Suporter</Button>
      </Space>
    </div>
  );
};
export default DevScreen;

// const renderEntries = (entries) => {
//   const group = lodash.groupBy(entries, "speaker");

//   const result = Object.entries(group)?.map(([speaker, arrays]) => {
//     const segment = arrays?.map((a) => a?.segment)?.join(" ");
//     return { speaker, segment };
//   });

//   return result;
// };
